<template>
  <a-modal
    v-model:visible="modal_visible"
    :title="`Aprobar solicitud por ${title}`"
    :closable="!loading"
    :maskClosable="!loading"
    centered
  >
    <a-typography-text strong>Resolución compañia</a-typography-text>
    <a-typography-title class="text-gray-8 fw-regular mb-4" :level="5">
      Escribe aquí los motivos por los cuales la compañía aseguradora está
      rechazando la solicitud
    </a-typography-title>
    <a-form ref="form_ref" :model="form_state" :rules="rules">
      <a-form-item name="message_text">
        <a-textarea
          placeholder="Resolución"
          v-model:value="form_state.message_text"
          :autoSize="{ minRows: 8, maxRows: 8 }"
        />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button @click="closeModal" :disabled="loading" key="back">
        Cancelar
      </a-button>
      <a-button
        @click="formValidation"
        :loading="loading"
        key="submit"
        :disabled="validTextMessage"
        type="primary"
      >
        Confirmar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { ref, reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { GET_LOGGED_USER, POST_CHANGE_REQUEST_STATE } from '@/store/types';
import notificiation from '@/utils/notifications';

export default {
  props: {
    requestType: {
      type: Number,
      default: 1
    },
    requestId: {
      type: [String, Number],
      default: ''
    }
  },
  setup(props, { emit }) {
    const modal_visible = ref(false);
    const loading = ref(false);
    const store = useStore();
    const validTextMessage = ref(false);
    const title = computed(() => {
      const types = {
        1: 'Ajuste retroactivo',
        2: 'Nota de crédito',
        3: 'Nota de débito'
      };

      return types[props.requestType];
    });

    const form_ref = ref();
    const form_state = reactive({
      message_text: ''
    });

    const rules = {
      message_text: [
        {
          required: true,
          message: 'Ingrese un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ]
    };

    const openModal = () => {
      modal_visible.value = true;
      validTextMessage.value = true;
    };

    const closeModal = () => {
      modal_visible.value = false;
    };

    const formValidation = () => {
      form_ref.value
        .validate()
        .then(() => {
          rejectRequest();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const rejectRequest = async () => {
      loading.value = true;
      try {
        const payload = {
          insurance_resolution: form_state.message_text,
          state: 3,
          brokerId: store.getters[GET_LOGGED_USER].id
        };

        await store.dispatch(POST_CHANGE_REQUEST_STATE, {
          id: props.requestId,
          payload
        });
        notificiation('success', 'Correcto', 'Solicitud Rechazada.');
        emit('rejectRequest', true);
        form_state.message_text = '';
        form_ref.value.resetFields();
        closeModal();
      } catch (error) {
        notificiation('error', 'Error', error.response.data.message);
      }
      loading.value = false;
    };
    watch(form_state, (val) => {
      if (val.message_text == '') {
        validTextMessage.value = true;
      } else {
        validTextMessage.value = false;
      }
    });

    return {
      modal_visible,
      title,
      form_state,
      rules,
      form_ref,
      loading,
      formValidation,
      openModal,
      closeModal,
      validTextMessage
    };
  }
};
</script>
